<template>
  <div class="ro-login account-box">
    <div class="ro-login-title">
      {{ letter.selectLoginType }}
    </div>
    <div class="other-login">
      <div
        v-for="(item, index) in thirdList"
        :key="index"
        class="third-box j-third-part-login"
      >
        <a
          class="login-type"
          href="javascript:;"
          :class="`j-${item}-login-btn ${$platformClass}`"
          @click="loginHrefJump(loginHref[item], false)"
        >
          <i :class="item"></i>
          <p class="name">{{ channelName[item] }}</p>
        </a>
      </div>
    </div>
    <button class="account-info j-account-info" @click="showPopup">
      沒有我的登錄方式？
    </button>
  </div>
</template>

<script type="text/javascript">
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import globalConfig from '../../utiles/globalConfig.js';

export default {
  name: 'accountLoginPage',
  data() {
    return {
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1'
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  mixins: [login],
  methods: {
    loginHrefJump(href, target) {
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    },
    showPopup() {
      this.$emit('showPopup', {
        title: '提示',
        content:
          '如您已經有了遊戲帳號，但未綁定Facebook、Google等登錄方式，需要先與遊戲帳號關聯：\n方法1：在web登入頁面選擇Facebook/Google等登入方式，登入後輸入與遊戲相同的賬密進行綁定；\n方法2：前往遊戲登錄完成Facebook/Google登入綁定；',
        contentStyle: 'text-align: left;font-size: 1.7vh;'
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
